module.exports = __webpack_public_path__ + "img/pg4-article2-c1.882ecbaa.png";